export default __webpack_public_path__ + "static/media/users_icon.6d692879.svg";